<template>
  <div class="this-resume page">
    <h1 class="title page-title">{{ $t('resume.title') }}</h1>

    <div class="duration">{{ $t('resume.duration') }}</div>

    <span class="time-line"></span>

<!--    code panda-->
    <div class="experience code-panda">
      <div class="period">
        <span>{{ $t('resume.codePanda.period') }}</span>
      </div>

      <div class="details right">
        <div class="company">{{ $t('resume.codePanda.company') }}</div>

        <div class="position">{{ $t('resume.codePanda.position') }}</div>

        <div class="tasks">
          <ul>
            <li>{{ $t('resume.codePanda.tasks.1') }}</li>

            <li>{{ $t('resume.codePanda.tasks.2') }}</li>

            <li>{{ $t('resume.codePanda.tasks.3') }}</li>
          </ul>
        </div>

        <div class="tasks sub-mission">
          <div class="customer">{{ $t('resume.codePanda.mission1.customer') }}</div>

          <div class="mission-duration">{{ $t('resume.codePanda.mission1.duration') }}</div>

          <ul>
            <li>{{ $t('resume.codePanda.mission1.tasks.1') }}</li>

            <li>{{ $t('resume.codePanda.mission1.tasks.2') }}</li>

            <li>{{ $t('resume.codePanda.mission1.tasks.3') }}</li>

          </ul>
        </div>

        <div class="tasks sub-mission">
          <div class="customer">{{ $t('resume.codePanda.mission2.customer') }}</div>

          <div class="mission-duration">{{ $t('resume.codePanda.mission2.duration') }}</div>

          <ul>
            <li>{{ $t('resume.codePanda.mission2.tasks.1') }}</li>

            <li>{{ $t('resume.codePanda.mission2.tasks.2') }}</li>

            <li>{{ $t('resume.codePanda.mission2.tasks.3') }}</li>

            <li>{{ $t('resume.codePanda.mission2.tasks.4') }}</li>

            <li>{{ $t('resume.codePanda.mission2.tasks.5') }}</li>
          </ul>
        </div>
      </div>
    </div>

<!--    enovea-->
    <div class="experience">
      <div class="period">
        <span>{{ $t('resume.enovea.period') }}</span>
      </div>

      <div class="details left">
        <div class="company">{{ $t('resume.enovea.company') }}</div>

        <div class="position">{{ $t('resume.enovea.position') }}</div>

        <div class="tasks">
          <ul>
            <li>{{ $t('resume.enovea.tasks.1') }}</li>

            <li>{{ $t('resume.enovea.tasks.2') }}</li>

            <li>{{ $t('resume.enovea.tasks.3') }}</li>
          </ul>
        </div>
      </div>
    </div>

<!--    auto entrepreneur-->
    <div class="experience">
      <div class="period">
        <span>{{ $t('resume.microCompany.period') }}</span>
      </div>

      <div class="details right">
        <div class="company">{{ $t('resume.microCompany.company') }}</div>

        <div class="position">{{ $t('resume.microCompany.position') }}</div>

        <div class="tasks">
          <ul>
            <li>{{ $t('resume.microCompany.tasks.1') }}</li>

            <li>{{ $t('resume.microCompany.tasks.2') }}</li>

            <li>{{ $t('resume.microCompany.tasks.3') }}</li>
          </ul>
        </div>
      </div>
    </div>

<!--    geokaps-->
    <div class= "experience">
      <div class="period">
        <span>{{ $t('resume.geokaps.period') }}</span>
      </div>

      <div class="details left">
        <div class="company">{{ $t('resume.geokaps.company') }}</div>

        <div class="position">{{ $t('resume.geokaps.position') }}</div>

        <div class="tasks">
          <ul>
            <li>{{ $t('resume.geokaps.tasks.1') }}</li>

            <li>{{ $t('resume.geokaps.tasks.2') }}</li>

            <li>{{ $t('resume.geokaps.tasks.3') }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Resume',
  props: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'src/assets/styles/variables';
  .this-resume {
    position: relative;
    display: flex;
    flex-direction: column;

    .duration {
      color: white;
      margin-bottom: 50px;
      font-weight: bold;
      font-size: 20px;
    }

    .time-line {
      height: calc(7 * 150px);
      width: 3px;
      border: 2px solid white;
      position: absolute;
      top: 343px;
    }

    .experience {
      position: relative;
      margin-bottom: 150px;
      &.code-panda {
        margin-bottom: 300px;
      }

      .period {
        background-color: white;
        height: 150px;
        width: 150px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          font-weight: bolder;
          color: $secondaryColor;
          width: 100%;
          text-align: center;
        }
      }

      .details {
        position: absolute;
        top: 0;

        .company {
          text-transform: uppercase;
          font-weight: bold;
          color: $mainColor;
        }

        .position {
          color: $mainColor;
        }
      }

      .tasks {
        color: $white;

        &.sub-mission {
          padding-left: 10px;
          .customer {
            color: $mainColor;
          }
          .mission-duration {
            padding-left: 25px;
            font-style: italic;
          }
          ul {
            padding-left: 25px;
          }
        }
      }
    }

    .experience:last-child {
      margin-bottom: 0;
    }
  }


  /* large screen */
  @media (min-width: 1200px) {
    .this-resume {
      align-items: center;

      .experience {
        .details {
          min-width: 40vw;

          &.right {
            right: -50px;
            -webkit-transform: translateX(100%);
            transform: translateX(100%);
          }
          &.left {
            left: -50px;
            -webkit-transform: translateX(-100%);
            transform: translateX(-100%);
            text-align: right;
          }
        }
      }
    }
  }

  /* small screen */
  @media (min-width: 640px) and (max-width: 1200px) {
    .this-resume {
      align-items: flex-start;

      .title, .duration {
        width: 100%;
        text-align: center;
      }

      .time-line {
        transform: translateX(75px);
      }

      .experience {
        .details {
          min-width: 60vw;

          &.right, &.left {
            right: -50px;
            -webkit-transform: translateX(100%);
            transform: translateX(100%);
            text-align: left;
          }
        }
      }
    }
  }

  /* mobile */
  @media (max-width: 640px) {
    .this-resume {
      align-items: flex-start;

      .title, .duration {
        width: 100%;
        text-align: center;
      }

      .time-line {
        transform: translateX(50px);
      }

      .experience {
        &:last-child {
          margin-bottom: 150px;
        }

        margin-bottom: 200px;

        .period {
          height: 100px;
          width: 100px;
          font-size: 14px;
        }
        .details {
          min-width: 55vw;

          &.right, &.left {
            right: -25px;
            -webkit-transform: translateX(100%);
            transform: translateX(100%);
            text-align: left;
          }
        }
      }
    }
  }
</style>
